import { LoyaltyCustomersGridView } from '~/components/loyalty/customers';
import { PageContainer } from '~/components/page-container';

export function LoyaltyCustomers() {
	return (
		<PageContainer>
			<LoyaltyCustomersGridView />
		</PageContainer>
	);
}
